import {useState, useEffect} from "react";
import {TextField, IconButton, InputAdornment} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

const CommonSearchFiled = ({
                               label = "Search",
                               initialSearchText = "",
                               onSearch = () => {
                               },
                               onClear = () => {
                               },
                               width = "400px",
                               borderRadius = "8px",
                               sx = {},
                               ...otherProps
                           }) => {
    const [inputValue, setInputValue] = useState(initialSearchText);
    const [showClearButton, setShowClearButton] = useState(false);

    // Update clear button visibility whenever inputValue changes
    useEffect(() => {
        setShowClearButton(inputValue !== "");
    }, [inputValue]);

    // Handle input change
    const handleChange = (event) => {
        setInputValue(event.target.value);
        if (event.target.value === "") {
            clearSearch();
        }
    };

    // Clear input field and trigger onClear
    const clearSearch = () => {
        setInputValue(""); // Clear input state
        setShowClearButton(false); // Hide clear button
        onClear(); // Trigger the onClear callback
    };

    // Trigger search action
    const handleSearch = (event) => {
        event.preventDefault();
        if (inputValue.trim() !== "") {
            onSearch(inputValue); // Trigger the onSearch callback with input
        }
    };

    useEffect(() => {
        setInputValue(initialSearchText);
    }, [initialSearchText]);

    return (
        <form onSubmit={handleSearch}>
            <TextField
                label={label}
                variant="outlined"
                value={inputValue}
                onChange={handleChange}
                sx={{
                    width: width,
                    [`& fieldset`]: {
                        borderRadius: borderRadius,
                    },
                    // [`& .MuiInputLabel-root`]: {
                    //     top: "50%", // Align vertically
                    //     transform: "translateY(-50%)", // Center it perfectly
                    //     left: "5%", // Center horizontally
                    //     // Ensure proper origin
                    //     textAlign: "center",
                    // },
                    // [`& .MuiInputLabel-shrink`]: {
                    //     top: "0", // Move to top when input is present
                    //     transform: "translateY(-50%) scale(0.75)", // Shrink and align
                    // },
                    // [`& .MuiOutlinedInput-root`]: {
                    //     display: "flex",
                    //     alignItems: "center", // Center input text
                    // },
                    marginBottom: "1px",
                    marginRight: "16px",
                    marginTop: "5px",
                    fontFamily: "Inter, Arial, sans-serif",
                    color: "#6F727A",
                    ...sx,
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={() => {
                                    if (showClearButton) {
                                        clearSearch();
                                    }
                                }}
                            >
                                {showClearButton ? <CloseIcon/> : <SearchIcon/>}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                {...otherProps}
            />
        </form>
    );
};

export default CommonSearchFiled;
